import {
  AlertTriangle,
  CheckCircle,
  Loader2,
  LucideIcon,
  XCircle,
} from 'lucide-react';
import { StatusTone } from '@/components/ui/statusTone.ts';
import { ImportStatus } from '@/features/dashboard/rawBankTransactions/types/ImportStatus.ts';

export const IMPORT_STATUS_LABELS: Record<ImportStatus, string> = {
  IN_PROGRESS: 'Import w toku',
  COMPLETED: 'Import zakończony',
  COMPLETED_WITH_ERRORS: 'Import zakończony z błędami',
  FAILED: 'Import nieudany',
};

export const IMPORT_STATUS_TONE: Record<ImportStatus, StatusTone> = {
  IN_PROGRESS: 'info',
  COMPLETED: 'success',
  COMPLETED_WITH_ERRORS: 'warning',
  FAILED: 'error',
};

export const IMPORT_STATUS_ICON: Record<ImportStatus, LucideIcon> = {
  IN_PROGRESS: Loader2,
  COMPLETED: CheckCircle,
  COMPLETED_WITH_ERRORS: AlertTriangle,
  FAILED: XCircle,
};
